window.sq = window.sq || {};
window.sq.config = window.sq.config || {};

window.sq.config.enableAnalytics = false;

window.sq.onData = function (data, opts) {
  if (opts.UIType === "dropdown") return data;

  for (let i = 0; i < data.results.length; ++i) {
    let item = data.results[i];

    let multiplePrice = item.variants.every(
      (x) => x.price === item.variants[0].price
    );

    var formattedPrice = Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(item.price);

    item.display_price_d = formattedPrice.split(".")[0] || "";
    item.display_price_c = formattedPrice.split(".")[1] || "";
    item.display_price_m = multiplePrice;

    var formattedComparePrice = Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(item.compare_at_price);

    item.compare_price_d = formattedComparePrice.split(".")[0] || "";
    item.compare_price_c = formattedComparePrice.split(".")[1] || "";

    let count = 0;

    if (item.productType === "Outlet") {
      count = item.variants[0].inventory_quantity;
    }

    if (item.productType === "Overstock" || item.productType === "Showroom") {
      item.variants.forEach((variant) => {
        count = count + variant.inventory_quantity;
      });
    }

    item.product_count = count;
  }

  return data;
};

window.sq.onItemComplete = function (el, item, variant, options) {
  window.sq.colorCount(el,item);
  // -- START supporting Visii required attributes --
  el.dataset.id = item.id;
  el.dataset.type = item.productType;
  // -- END supporting Visii required attributes --

  var sqPriceElement = null;
  var sqComparePriceElement = null;
  let sqFrom = "";
  let count = 0;

  if (options.UIType === "dropdown") {
    sqPriceElement = el.querySelector(".sale-price.sq-amount");
    sqComparePriceElement = el.querySelector(".discount-price.sq-amount");
  }

  if (sqPriceElement) {
    var formattedPrice = Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(item.price);

    let multiplePrice = item.variants.every(
      (x) => x.price === item.variants[0].price
    );
    if (!multiplePrice) {
      sqFrom = "From ";
    }

    let priceDollars = formattedPrice.split(".")[0] || "";
    let priceCents = formattedPrice.split(".")[1] || "";
    sqPriceElement.innerHTML =
      `<span class='sq-multiple-prices'>${sqFrom} </span> ` +
      `<span class="sq-dollar-sign">$</span> ` +
      `<span class="sq-amount-dollars">${priceDollars.replace(
        "$",
        ""
      )}</span>` +
      `<span class="sq-amount-cents">${priceCents.replace(".", "")}</span>`;
  }

  if (sqComparePriceElement) {
    var formattedComparePrice = Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(item.compare_at_price);

    let comparePriceDollars = formattedComparePrice.split(".")[0] || "";
    let comparePriceCents = formattedComparePrice.split(".")[1] || "";
    sqComparePriceElement.innerHTML =
      `<span class="sq-dollar-sign">$</span> ` +
      `<span class="sq-amount-dollars">${comparePriceDollars.replace(
        "$",
        ""
      )}</span>` +
      `<span class="sq-amount-cents">${comparePriceCents.replace(
        ".",
        ""
      )}</span>`;
  }
};

window.sq.colorCount = function(el,item){
  setTimeout(function () {
  let variantSwatchElements = el.querySelectorAll('span.sq-color-swatch-color.sparq-tooltip-top');
  let colorSwatchContainer = el.querySelector('.sq-price-container'); //.sq-color-swatch
  if(!!variantSwatchElements){
    let count = Array.from(variantSwatchElements).length;
    if(count === 0 ){
      return;
    }
      let html = `<div class="sq-plus">${count} colors available</div>`;
        if(colorSwatchContainer){
          colorSwatchContainer.insertAdjacentHTML("afterend",html)
        }
  }
}, 5);
}

window.sq.onComplete = (el,opts) =>{
  window.sq.quickShip(el,opts);
}

window.sq.quickShip = (el,opts) =>{
  if(opts.UIType === 'dropdown') return;
  let quickship = el.querySelector(".sparq-sidebar.box-shadow.sparq-list-box-tags_quick_ship_4ocszqidsundmcw95p7desi8 span.capitalize.filter-width");
  if(!quickship) return;
  quickship.innerHTML = 'QuickShip'
}